const baseLink = process.env.REACT_APP_API_BE_URL

// course link

const demandLink = `${baseLink}/courses/get-demand`

const dojoLink = `${baseLink}/courses/get-course-dojo`

const allLink = `${baseLink}/courses/get-all`

const detailLink = `${baseLink}/courses/detail`

const contactLink = `${baseLink}/contact`

const courseLink = `${baseLink}/courses/get-course`

// course sign

const signLink = `${baseLink}/courses/sign` 



export {
    demandLink , 
    dojoLink , 
    allLink , 
    detailLink , 
    contactLink , 
    courseLink , 
    signLink
}